import { cn } from "@/lib/utils";

interface KiiBadgeProps {
  children: React.ReactNode;
  variant?: "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "info" | "dev";
  className?: string;
  onClick?: () => void;
  "data-testid"?: string;
}

export function KiiBadge({
  children,
  variant = "default",
  className,
  onClick,
  "data-testid": dataTestId,
}: KiiBadgeProps) {
  const variantClasses = {
    default: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    destructive: "bg-destructive text-destructive-foreground",
    outline: "border border-input bg-transparent text-foreground",
    success: "bg-green-600 text-white",
    warning: "bg-yellow-500 text-black",
    info: "bg-blue-600 text-white",
    dev: "bg-fuchsia-600 text-white",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center shrink-0 rounded px-1.5 py-0.5 text-[10px] font-medium whitespace-nowrap",
        variantClasses[variant],
        onClick && "cursor-pointer",
        className
      )}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </span>
  );
}
